// Human-readable labels for the anti-fraud stage's "why the vision model was not consulted"
// keys (metrics_json.llm.error / fraud.llm.error). Unknown keys are shown verbatim.
const LLM_ERROR_LABEL: Record<string, string> = {
  not_called: "model not consulted",
  not_grey: "model not consulted — no fraud signals to settle",
  mode_never: "model disabled (ANTIFRAUD_LLM_MODE=never)",
  daily_cap: "daily model-call cap reached",
  no_api_key: "no OpenRouter key configured",
  no_frames: "could not sample frames from the video",
  disabled: "anti-fraud stage disabled",
};

export function llmErrorLabel(error: string | null | undefined): string | null {
  if (!error) return null;
  return LLM_ERROR_LABEL[error] ?? error;
}
